/// Світла тема обовʼязкова, темна бажана — рецепції часто в темних зонах.
///
/// Клас на `<html>`, як вимагає контракт токенів. Вибір зберігається локально:
/// це властивість робочого місця (монітор у підвалі), а не людини.

import { THEME_KEY as KEY } from '@/constants/storage-keys'

export type Theme = 'light' | 'dark'

export const readTheme = (): Theme => (localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light')

export const applyTheme = (theme: Theme): void => {
  document.documentElement.classList.toggle('dark', theme === 'dark')
  localStorage.setItem(KEY, theme)
}
